module.exports = __webpack_public_path__ + "media/assets/7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/7.svg
// module id = 19
// module chunks = 0